<div *ngIf="workerMail" (click)="preventClickEvent($event)">
  <!-- s3にデータがある場合 -->
  <!-- 生メール -->
  <ng-container *ngIf="workerMail.rawdata_url">
    <!-- スキルシート -->
    <ng-container *ngFor="let attached_file of workerMail.attached_files; last as last">
      <ng-container *ngIf="last">
        <a class="btn btn-dark float-left border-0 skill-sheet" href="#" placement="top"
          *ngIf="attached_file.name !== 'skill_sheets.zip'" (click)="createActionLog('skillsheet')">
          <i class="fa fa-file-text-o" (click)="openReader(attached_file.file_info_url)"
            ngbTooltip="オンラインで見る: {{ attached_file.name }}" container="body"></i>
          <i class="fa fa-download skill-sheet-download" (click)="downloadSkillSheet(attached_file.file_info_url, attached_file.name)"
            ngbTooltip="スキルシートダウンロード: {{ attached_file.name }}" container="body"></i>
        </a>

        <!-- スキルシートが複数添付ファイルの場合（zipファイル）、元メールデータをダウンロードできるように変更 -->
        <a class="btn btn-dark float-left border-0" ngbTooltip="複数添付ファイルがあるので元メールがDLされます" container="body" href="#"
          placement="top" *ngIf="attached_file.name == 'skill_sheets.zip'" (click)="downloadMailFile()"
          (click)="createActionLog('eml')"><i class="fa fa-file-text-o"></i></a>
      </ng-container>
    </ng-container>
  </ng-container>
</div>
